import Api from './Api';
import Configuracao from '../util/Configuracao';
import { parse } from 'date-fns';

class VigenciaPorteApi extends Api {
  async consultarVigencias (codPorte) {
    try {
      const vigenciasUrl = Configuracao.getConfiguracao().urlConsultarVigencias + codPorte;
      const response = await this.fetch(vigenciasUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPortes () {
    try {
      const portesUrl = Configuracao.getConfiguracao().urlConsultarPortes;
      const response = await this.fetch(portesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirVigencia (vigencia) {
    try {
      const urlIncluirVigencia = Configuracao.getConfiguracao().urlIncluirVigencia;
      const response = await this.fetch(urlIncluirVigencia, 'put', vigencia);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirVigencia (codVigencia) {
    try {
      const urlExcluirVigencia = Configuracao.getConfiguracao().urlExcluirVigencia + codVigencia;
      const response = await this.fetch(urlExcluirVigencia, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarVigencia (vigencia) {
    try {
      const urlAlterarVigencia = Configuracao.getConfiguracao().urlAlterarVigencia;
      const response = await this.fetch(urlAlterarVigencia, 'put', vigencia);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async validarVigencia (vigencia, indInclusao) {
    try {
      const urlValidarVigencia = Configuracao.getConfiguracao().urlValidarVigencia + indInclusao;
      const result = await this.fetch(urlValidarVigencia, 'post', vigencia);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async cancelarVigencia (codVigencia, motivoCancelamento) {
    try {
      const urlCancelarVigencia = Configuracao.getConfiguracao().urlCancelarVigencia + codVigencia + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarVigencia, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoVigencia (codVigencia) {
    try {
      const urlDesfazerCancelamentoVigencia = Configuracao.getConfiguracao().urlDesfazerCancelamentoVigencia + codVigencia;
      const response = await this.fetch(urlDesfazerCancelamentoVigencia, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarValorPorte (codPorteAnestesico, dataRealizacao) {
    try {
      const valorPorteUrl = Configuracao.getConfiguracao().valorPorteUrl + codPorteAnestesico + '/' + parse(dataRealizacao);
      const response = await this.fetch(valorPorteUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default VigenciaPorteApi;
